var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgColorLeft = function SvgColorLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 37,
    viewBox: "0 0 3.23 2.99",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43 1.09c-.01.16-.13.19-.26.18-.13-.02-.21-.04-.23-.18-.03-.15.06-.26.2-.31.24-.07.29.12.29.31z",
    fill: "#005bbc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 .58c.11.04.19.11.2.25.02.22-.3.4-.51.08-.07-.09-.01-.28.14-.32.06-.01.11-.03.17-.01z",
    fill: "#ffd600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66 1.47c0 .23-.59.38-.49-.15.04-.24.48-.23.49.15z",
    fill: "#ff5252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 1.94c.12.14-.03.34-.21.38-.11.03-.18-.01-.22-.14-.04-.11-.02-.26.12-.31.12-.04.22-.03.31.07z",
    fill: "#6cd48d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.4 1.98c.09-.06.22-.04.28.05.06.09.04.22-.05.28-.01.01 0 .01-.02.03l-.01.01-.09.12c.03.03.07.07.11.1l.07.07c.08.08.08.2 0 .28-.08.08-.2.09-.28.01l-.07-.06-.16-.16C.17 2.7.15 2.69.14 2.68a.5.5 0 0 1-.08-.07c-.09-.12-.09-.22.05-.32.06-.05.13-.13.18-.19l.01-.02.1-.1zm2.5.52c-.27.3-.59.45-.88.48a.938.938 0 0 1-.48-.07.736.736 0 0 1-.35-.3.807.807 0 0 1-.07-.64c.02-.07.03-.15.02-.17 0-.01-.02.01-.08.01-.2 0-.37-.03-.51-.12-.15-.1-.24-.26-.27-.48C.25.93.4.65.66.43.9.22 1.24.06 1.6.02c.46-.07.83.07 1.11.3.14.13.26.28.34.45.09.17.14.35.16.54.06.43-.04.88-.31 1.19zm-.92.08c.2-.02.42-.12.61-.34.2-.23.27-.56.22-.88-.01-.14-.06-.28-.12-.41a.96.96 0 0 0-.25-.32C2.25.46 1.99.37 1.65.42c-.27.03-.54.15-.73.31-.16.14-.25.29-.24.44.02.09.05.15.1.18.06.04.15.06.27.06.28-.01.41.09.47.25.05.13.02.27-.01.41-.04.14-.02.25.02.33.04.06.1.11.17.14.08.04.18.05.28.04z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgColorLeft;